import React from "react";

//Menu
import HomeIcon from "@mui/icons-material/Home";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import PaidIcon from "@mui/icons-material/Paid";
import EngineeringIcon from "@mui/icons-material/Engineering";
import ReceiptIcon from "@mui/icons-material/Receipt";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import GavelIcon from "@mui/icons-material/Gavel";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import DeveloperModeIcon from '@mui/icons-material/DeveloperMode';
import PeopleIcon from '@mui/icons-material/People';

//Others
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import SettingsIcon from "@mui/icons-material/Settings";
import GroupIcon from "@mui/icons-material/Group";
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat';
import { FEATURES } from "../../config/features";


const cashAdvanceMenu = FEATURES.CASH_ADVANCE_MODULE
  ? [{ name: "Cash Advance", link: "/cashAdvance" }]
  : [];

export const SidebarDataMenu = [
  {
    title: "Home",
    icon: <HomeIcon />,
    link: "/",
  },
  {
    title: "Personnel",
    icon: <ManageAccountsIcon />,
    children: [
      {
        name: "Add Employee",
        link: "/addEmployee",
      },
      {
        name: "Employee Information",
        link: "/employeeInformation",
      },
      {
        name: "Employee List",
        link: "/employeesList",
      },
      {
        name: "Employee Heirarchy",
        link: "/employeeHeirarchy",
      },
      {
        name: "Employment Status",
        link: "/employmentStatus",
      },
      {
        name: "Employee Schedule",
        link: "/employeeSchedule",
      },
      {
        name: "Employee Reliever",
        link: "/employeeReliever",
      },
      {
        name: "On Boarding Personnel",
        link: "/onBoardingPersonnel",
      },
      {
        name: "On Boarding",
        link: "/onBoarding",
      },
      {
        name: "Out Boarding",
        link: "/outBoarding",
      },
      {
        name: "Employee Transaction",
        link: "/employeeTransaction",
      },
      {
        name: "Crew List",
        link: "/crewList",
      },
      {
        name: "Employee Request",
        link: "/employeeRequest",
      },
      {
        name: "Employee Type Tagging",
        link: "/employeeTypeTagging",
      },
      {
        name: "Uploading Schedule",
        link: "/uploadingSchedule",
      },
      {
        name: "Medical Clearance",
        link: "/medicalClearance",
      },
    ],
  },
  {
    title: "Talent Management",
    icon: <PeopleIcon />,
    children: [
      {
        name: "MRF",
        link: "/mrf",
      },
      {
        name: "Training/Seminar Program",
        link: "/trainingAndSeminarProgram",
      },
      {
        name: "Kpi Performance Appraisal",
        link: "/kpiPerformanceAppraisal",
      }
    ],
  },
  {
    title: "Time Keeping",
    icon: <AccessTimeFilledIcon />,
    children: [
      {
        name: "Time Entries",
        link: "/timeKeeping",
      },
      {
        name: "Tampered Approval",
        link: "/tamperedApproval",
      },
      {
        name: "Shift Schedule",
        link: "/shiftSchedule",
      },
      {
        name: "Upload Time Entries File",
        link: "/uploadTimeEntriesFile",
      },
      {
        name: "Upload Days Entries",
        link: "/uploadDaysEntries",
      },
      {
        name: "Upload CVT Logs",
        link: "/uploadCvtLogs",
      }
    ],
  },
  {
    title: "Payroll",
    icon: <PaidIcon />,
    children: [
      {
        name: "Leave Incentive Batch",
        link: "/leaveIncentiveBatch",
      },
      {
        name: "Process Partial Salary",
        link: "/processPartialSalary",
      },
      {
        name: "Process Payroll",
        link: "/payroll",
      },
      {
        name: "13th Month",
        link: "/thirteenthMonth",
      },
      {
        name: "Final Pay",
        link: "/finalPay",
      },
      {
        name: "Subcon",
        link: "/subcon",
      },
      {
        name: "Agency",
        link: "/agency",
      },
      {
        name: "Payroll Period",
        link: "/payrollPeriod",
      },
      {
        name: "Partial Salary",
        link: "/partialSalary",
      },
      {
        name: "Partial Salary Batch",
        link: "/partialSalaryBatch",
      },
    ],
  },
  {
    title: "Maintenance",
    icon: <EngineeringIcon />,
    children: [
      /* {
                name: "Announcement",
                link: "/announcement"
            }, */
      {
        name: "HR Calendar",
        link: "/hrCalendar",
      },
      {
        name: "Client",
        link: "/client",
      },
      {
        name: "Pay Type",
        link: "/payType",
      },
      {
        name: "Holiday",
        link: "/holiday",
      },
      {
        name: "Holiday Type",
        link: "/holidayType",
      },
      {
        name: "Leave Types",
        link: "/leaveTypes",
      },
      {
        name: "Division",
        link: "/division",
      },
      {
        name: "Department",
        link: "/department",
      },
      {
        name: "Section",
        link: "/section",
      },
      {
        name: "Classification",
        link: "/classification",
      },
      {
        name: "Company",
        link: "/company",
      },
      {
        name: "Position",
        link: "/position",
      },
      {
        name: "Employee Status",
        link: "/employeeStatus",
      },
      {
        name: "Job Title",
        link: "/jobTitle",
      },
      {
        name: "Employee Group 1",
        link: "/employeeGroup1",
      },
      {
        name: "Employee Group 2",
        link: "/employeeGroup2",
      },
      {
        name: "Location",
        link: "/location",
      },
      {
        name: "Time Keeper",
        link: "/timeKeeper",
      },
      {
        name: "Plantilya",
        link: "/plantilya",
      },
      {
        name: "Cost Center",
        link: "/costCenter",
      },
      {
        name: "Payroll Journal Account",
        link: "/payrollJournalAccount",
      },
      {
        name: "Requirements",
        link: "/onBoardingRequirements",
      },
      {
        name: "Out Boarding Requirements",
        link: "/outBoardingRequirements",
      },
      {
        name: "Kpi Legend",
        link: "/kpiLegend",
      },
      {
        name: "Vessel",
        link: "/vessel",
      },
      {
        name: "Vessel Status",
        link: "/vesselStatus",
      },
      {
        name: "Vessel Function",
        link: "/vesselFunction",
      },
      {
        name: "Destination",
        link: "/destination",
      },
      {
        name: "Distant Water",
        link: "/distantWater",
      },
      {
        name: "Area Of Operation",
        link: "/areaOfOperation",
      },
      {
        name: "Sub Area",
        link: "/subArea",
      },
      {
        name: "Vessel Class",
        link: "/vesselClass",
      },
      {
        name: "Operation Group",
        link: "/operationGroup",
      },
      {
        name: "Vessel Type",
        link: "/vesselType",
      },
      {
        name: "Employee Type",
        link: "/employeeType",
      },
      {
        name: "Memo Type",
        link: "/memoType",
      },
      {
        name: "Partial Salary Schedule",
        link: "/partialSalarySchedule",
      },
      {
        name: "Clinic Requirements",
        link: "/clinicRequirements",
      },
      {
        name: "Salary Advance Deduction Bracket",
        link: "/salaryAdvanceDeductionBracket",
      },
      {
        name: "Payroll Reason Code",
        link: "/payrollReasonCode",
      },
      {
        name: "Loans Access",
        link: "/loansAccess",
      },
      {
        name: "MRF Access",
        link: "/mrfAccess",
      },
      {
        name: "Employee Request Access",
        link: "/employeeRequestAccess",
      },
      {
        name: "Employee Transaction Access",
        link: "/employeeTransactionAccess",
      },
      {
        name: "Medical Clearance Access",
        link: "/medicalClearanceAccess",
      },
      {
        name: "Salary Advance Access",
        link: "/salaryAdvanceAccess",
      },
    ],
  },
  {
    title: "Vessel Module",
    icon: <DirectionsBoatIcon />,
    children: [
      { name: "Vessel 201", link: "/vessel201" },
    ],
  },
  {
    title: "Salary Module",
    icon: <AccountBalanceIcon />,
    children: [
      {
        name: "Employee Monthly Salary",
        link: "/employeeMonthlySalary",
      },
      {
        name: "Employee Daily Salary",
        link: "/employeeDailySalary",
      },
      {
        name: "Quota-Based Salary",
        link: "/quotaBasedSalary",
      },
      {
        name: "Position - Designation Salary",
        link: "/positionDesignationSalary",
      },
      {
        name: "Maintenance Salary Combination",
        link: "/maintenanceSalaryCombination",
      },
      {
        name: "Employee Bank Account",
        link: "/employeeBankAccount",
      },
    ],
  },
  {
    title: "Government Premiums",
    icon: <GavelIcon />,
    children: [
      {
        name: "BIR / Tax",
        link: "/tax",
      },
      {
        name: "Pagibig",
        link: "/pagibig",
      },
      {
        name: "SSS",
        link: "/sss",
      },
      {
        name: "Philhealth",
        link: "/philhealth",
      },
    ],
  },
  {
    title: "Transactions",
    icon: <ReceiptIcon />,
    children: [
      {
        name: "DTR (Admin's View)",
        link: "/dtr",
      },
      {
        name: "DTR (Employee's View)",
        link: "/dtrBiometrics",
      },
      {
        name: "DTR With OT Viewing",
        link: "/dtrWithOTViewing",
      },
      {
        name: "Offset Credits",
        link: "/offsetCredits",
      },
      {
        name: "Mobile DTR Approval",
        link: "/mobileDTRApproval",
      },
      {
        name: "Approver Hierarchy",
        link: "/approverHierarchy",
      },
      {
        name: "Approver Hierarchy Per Location",
        link: "/approverHierarchyPerLocation",
      },
      {
        name: "Approver Per Maintenance",
        link: "/approverMaintenance",
      },
      {
        name: "Request Approval",
        link: "/requestApproval",
      },
      {
        name: "Request Approval Time Keeper",
        link: "/requestApprovalTimeKeeper",
      },
      {
        name: "Mass Approval",
        link: "/massApproval",
      },
      {
        name: "DTR Correction Workers",
        link: "/dtrCorrectionWorkers",
      },
      {
        name: "Leave Encashment",
        link: "/leaveEncashment",
      },
      {
        name: "Overtime",
        link: "/overtime",
      },
      {
        name: "DTR Correction",
        link: "/dtrCorrection",
      },
      {
        name: "Leave",
        link: "/leave",
      },
      {
        name: "Change of Schedule",
        link: "/changeOfSchedule",
      },
      {
        name: "Offset Request",
        link: "/offsetRequest",
      },
      {
        name: "Salary Advance Request",
        link: "/salaryAdvanceRequest",
      },
    ],
  },
  {
    title: "Loans & Benefits",
    icon: <CreditScoreIcon />,
    children: [
      {
        name: "Loan Transaction",
        link: "/loanTransaction",
      },
      {
        name: "SSS Loan",
        link: "/sssLoan",
      },
      {
        name: "SSS Emergency Loan",
        link: "/sssEmergencyLoan",
      },
      {
        name: "SSS Calamity Loan",
        link: "/sssCalamityLoan",
      },
      {
        name: "Pagibig Loan",
        link: "/pagibigLoan",
      },
      {
        name: "Pagibig Calamity Loan",
        link: "/pagibigCalamityLoan",
      },
      ...cashAdvanceMenu,
      { name: "Salary Advance", link: "/salaryAdvance" },
      {
        name: "Loans",
        link: "/loans",
      },
      {
        name: "Deductions",
        link: "/deductions",
      },
      {
        name: "Benefits",
        link: "/benefits",
      },
    ],
  },
  {
    title: "Dev Mode",
    icon: <DeveloperModeIcon />,
    children: [
      {
        name: "DTR Rules Configuration",
        link: "/dtrRulesConfiguration",
      },
      {
        name: "Payroll Rate Config",
        link: "/payrollRateConfig",
      },
      {
        name: "OT Formulas",
        link: "/otFormulas",
      },
      {
        name: "Monthly Working Days Formulas",
        link: "/monthlyWorkingDaysFormulas",
      },
      {
        name: "Night Differential",
        link: "/nightDifferential",
      },
      {
        name: "Gov Premium Formulas",
        link: "/govPremiumFormulas",
      },
      {
        name: "Client Identity",
        link: "/clientIdentity",
      },
      {
        name: "Grace Period",
        link: "/gracePeriod",
      },
      {
        name: "Excel Upload Helper",
        link: "/excelUploadHelper",
      },
      {
        name: "Leave Types Dev",
        link: "/leaveTypesDev",
      },
      {
        name: "Dev Test",
        link: "/devTest",
      },
      {
        name: "Dev Hobby",
        link: "/devHobby",
      },
    ],
  },
];

export const SidebarDataOthers = [
  {
    title: "Reports",
    icon: <ReportProblemIcon />,
    children: [
      {
        name: "BIR Form No. 2316",
        link: "/BIR2316",
      },
      {
        name: "BIR Form No. 0619E",
        link: "/BIR0619E",
      },
      {
        name: "BIR Form No. 0619F",
        link: "/BIR0619F",
      },
      {
        name: "BIR Form No. 1601C",
        link: "/BIR1601C",
      },
      {
        name: "Alphalist",
        link: "/alphalist",
      },
      {
        name: "SSS Summary",
        link: "/sss-report",
      },
      {
        name: "Pagibig Summary",
        link: "/pagibig-report",
      },
      {
        name: "Philhealth Summary",
        link: "/philhealth-report",
      },
      {
        name: "Certificate Of SSS",
        link: "/certificateOfSSS",
      },
      {
        name: "Certificate Of Pagibig",
        link: "/certificateOfPagibig",
      },
      {
        name: "Certificate Of Philhealth",
        link: "/certificateOfPhilhealth",
      },
      {
        name: "Certificate Of Employment",
        link: "/certificateOfEmployment",
      },
      {
        name: "Loan Report",
        link: "/loanReport",
      },
      {
        name: "Per Day Tracker",
        link: "/perDayTracker",
      },
      {
        name: "Overtime Summary Report",
        link: "/overtimeSummaryReport",
      },
      {
        name: "Tracker Report",
        link: "/trackerReport",
      },
      {
        name: "Payslip",
        link: "/payslip",
      },
      {
        name: "Payroll Register",
        link: "/payrollRegister",
      },
      {
        name: "Resigned",
        link: "/resigned",
      },
      {
        name: "Active Employees",
        link: "/activeEmployees",
      },
      {
        name: "Year of Service",
        link: "/yearOfService",
      },
      {
        name: "SSS Loan Report",
        link: "/sssLoan-report",
      },
      {
        name: "Pagibig Loan Report",
        link: "/pagibigLoan-report",
      },
      {
        name: "201 Report",
        link: "/201report",
      },
      {
        name: "Attendance Report",
        link: "/attendanceReport",
      },
      {
        name: "Bank Transmittal Report",
        link: "/bankTransmittalReport",
      },
      {
        name: "Bank Transmittal BDO",
        link: "/bankTransmittalBDO",
      },
      {
        name: "Bank Transmittal BPI",
        link: "/bankTransmittalBPI",
      },
      {
        name: "Bank Transmittal China Bank Savings",
        link: "/bankTransmittalChinaBankSavings",
      },
      {
        name: "Bank Transmittal HSBC",
        link: "/bankTransmittalHSBC",
      },
      {
        name: "Bank Transmittal Security Bank",
        link: "/bankTransmittalSecurityBank",
      },
      {
        name: "Summary Of Tardiness",
        link: "/summaryOfTardiness",
      },
      {
        name: "Absences Memo",
        link: "/absencesMemo",
      },
      {
        name: "Absences Report",
        link: "/absencesReport",
      },
      {
        name: "Action History Report",
        link: "/actionHistoryReport",
      },
      {
        name: "Allowance Summary",
        link: "/allowanceSummary",
      },
      {
        name: "Audit Trail Report - Employee Setup",
        link: "/auditTrailReportEmployeeSetup",
      },
      {
        name: "Bundy Clock Usage",
        link: "/bundyClockUsage",
      },
      {
        name: "Basic Pay Adjustment Report",
        link: "/basicPayAdjustmentReport",
      },
      {
        name: "Commissions Summary",
        link: "/commissionsSummary",
      },
      {
        name: "Cost Center Report",
        link: "/costCenterReport",
      },
      {
        name: "DTR Report",
        link: "/dtrReport",
      },
      {
        name: "Earnings Per Month",
        link: "/earningsPerMonth",
      },
      {
        name: "Deductions Per Month",
        link: "/deductionsPerMonth",
      },
      {
        name: "Employee Leave Group",
        link: "/employeeLeaveGroup",
      },
      {
        name: "Employee Overtime Group",
        link: "/employeeOvertimeGroup",
      },
      {
        name: "Employee Expense Group",
        link: "/employeeExpenseGroup",
      },
      {
        name: "Employee Leave History",
        link: "/employeeLeaveHistory",
      },
      {
        name: "Employee Listing By Hiring Date",
        link: "/employeeListingByHiringDate",
      },
      {
        name: "Employee Register",
        link: "/employeeRegister",
      },
      {
        name: "Expense Report",
        link: "/expenseReport",
      },
      {
        name: "Government Employee Inventory",
        link: "/governmentEmployeeInventory",
      },
      {
        name: "Headcount Report",
        link: "/headcountReport",
      },
      {
        name: "Holiday Premium Summary",
        link: "/holidayPremiumSummary",
      },
      {
        name: "Leave Ledger Report",
        link: "/leaveLedgerReport",
      },
      {
        name: "Leave Summary Report",
        link: "/leaveSummaryReport",
      },
      {
        name: "Loan History",
        link: "/loanHistory",
      },
      {
        name: "Loan Payments Summary",
        link: "/loanPaymentsSummary",
      },
      {
        name: "Loans Monthly Amortization Summary",
        link: "/loansMonthlyAmmortizationSummary",
      },
      {
        name: "Loans Penalty History",
        link: "/loansPenaltyHistory",
      },
      {
        name: "Night Differential Summary",
        link: "/nightDifferentialSummary",
      },
      {
        name: "Non Taxable Allowances Report",
        link: "/nonTaxableAllowancesReport",
      },
      {
        name: "Other Earnings Report",
        link: "/otherEarningsReport",
      },
      {
        name: "Other Deductions Summary",
        link: "/otherDeductionsSummary",
      },
      {
        name: "Outstanding Loans",
        link: "/outstandingLoans",
      },
      {
        name: "Payroll Cash Register",
        link: "/payrollCashRegister",
      },
      {
        name: "Payroll Check Register",
        link: "/payrollCheckRegister",
      },
      {
        name: "Payroll Debit Memo",
        link: "/payrollDebitMemo",
      },
      {
        name: "Payroll Journal By Cost Center",
        link: "/payrollJournalByCostCenter",
      },
      {
        name: "Payroll Journal By Department",
        link: "/payrollJournalByDepartment",
      },
      {
        name: "Payroll Journal By Summary",
        link: "/payrollJournalBySummary",
      },
      {
        name: "Payroll Per Payment Method",
        link: "/payrollPerPaymentMethod",
      },
      {
        name: "Select Logs",
        link: "/selectLogs",
      },
      {
        name: "Summary Report By Month And Department",
        link: "/summaryReportByMonthAndDepartment",
      },
      {
        name: "Tardiness Memo",
        link: "/tardinessMemo",
      },
      {
        name: "Time Keeping History Detailed Report",
        link: "/timeKeepingHistoryDetailedReport",
      },
      {
        name: "Time Keeping Hours Worked Report",
        link: "/timeKeepingHoursWorkedReport",
      },
      {
        name: "Time Keeping Hours Worked Summary",
        link: "/timeKeepingHoursWorkedSummary",
      },
      {
        name: "Timesheet Status Report",
        link: "/timesheetStatusReport",
      },
      {
        name: "YTD Deduction Summary",
        link: "/ytdDeductionSummary",
      },
      {
        name: "YTD Earnings Summary",
        link: "/ytdEarningsSummary",
      },
      {
        name: "YTD Payroll Register",
        link: "/ytdPayrollRegister",
      },
      {
        name: "SSS Employment Report (R-1A)",
        link: "/reportR1A",
      },
      {
        name: "SSS Contribution Collection List (R-3)",
        link: "/reportR3",
      },
      {
        name: "SSS Contribution Collection List Summary (R-5)",
        link: "/reportR5",
      },
      {
        name: "SSS Member Loan Collection List (ML-1)",
        link: "/reportML1",
      },
      {
        name: "Employee Contribution History (Philhealth)",
        link: "/employeeContributionHistory",
      },
      {
        name: "Salary Loan Deduction Report",
        link: "/salaryLoanDeductionReport",
      },
      {
        name: "SSS Calamity Loan Report",
        link: "/calamityLoanDeductionSummary",
      },
      {
        name: "Membership Contribution Remittance Form (MCRF)",
        link: "/reportMCRFModule",
      },
      {
        name: "Short-Term Loan Remittance (STL)",
        link: "/reportSTL",
      },
      {
        name: "Housing Loan Remittance Report",
        link: "/reportHousingLoan",
      },
      {
        name: "Employer's Remittance Report (RF-1)",
        link: "/reportRF1",
      },
      {
        name: "Report of Employee-Members (ER-2)",
        link: "/reportER2",
      },
      {
        name: "Employee Contribution Ledger (Philhealth)",
        link: "/employeeContributionLedger",
      },
      {
        name: "Separated Employee Report",
        link: "/separatedEmployeeReport",
      },
    ],
  },
  {
    title: "Settings",
    icon: <SettingsIcon />,
    link: "/settings",
  },
  {
    title: "Calendar",
    icon: <CalendarMonthIcon />,
    link: "/calendar",
  },
  {
    title: "Users",
    icon: <GroupIcon />,
    link: "/users",
  },
];

export const extractMenuItems = (menu) => {
  return menu.flatMap((item) =>
    item.children
      ? item.children.map((child) => ({ name: child.name, link: child.link }))
      : [{ name: item.title, link: item.link }]
  );
};
